import React, { Component } from "react";
import { Card, Divider, Icon, Table, Button, Popconfirm, message, Spin } from "antd";
import { decode } from 'utf8'
import Modal from './Modal';
import ModalEdit from './ModalEdit';
import ModalDelete from './ModalDelete';

import { connect } from "react-redux";

import {
  fetchStores,// fetchCoupon
} from "appRedux/actions/Coupons";

function confirm(e) {
  message.success('Eliminaste este cupón.');
}

function cancel(e) {
  message.error('Este cupón no se elimino.');
}

const columns = [
  {
    title: 'Tienda',
    dataIndex: 'name',
    key: 'name',
    render: text => <span>{text}</span>,
  }, {
    title: 'Teléfono',
    dataIndex: 'phone',
    key: 'phone',
  }, {
    title: 'Correo',
    dataIndex: 'email',
    key: 'email',
  }
  ,

  {
    title: 'Acción',
    key: 'action',


    render: (text, record) => (
      <span>
        <ModalEdit recording={record} />
        <ModalDelete recording={record} />
      </span>
    ),
  }

];


class Simple extends Component {

  componentDidMount() {
    this.props.fetchStores();
  }

  render() {
    const { placeStores } = this.props;

    let placeStoresDecode = [];
    placeStoresDecode = placeStores.map( (place)=> {
      return ({
        id: place.id,
        name: decode(place.name),
        email: place.email,
        phone: place.phone,
      })
    });

    if (placeStoresDecode == 0) {
        return  <Spin className="gx-loader-container" />;
    }



    return (
      <Card title="Tiendas">
        <Modal />
        <br />
        <Table className="gx-table-responsive" columns={columns} dataSource={placeStoresDecode} />
      </Card>
    );
  }
};

function mapStateToProps({ placeStores }) {
  return {
    placeStores
  }
}

export default connect(mapStateToProps, { fetchStores })(Simple);


// WEBPACK FOOTER //
// ./src/routes/main/Store/Table.js